import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { ColorPaper } from '@/components/ui/Surface/ColorPaper';
import { Text } from '@/components/ui/Typography/Body/Text';
import { WithAnnotationText } from '@/components/ui/Typography/Body/WithAnnotationText/WithAnnotationText';
/**
 * クライアント：ファイル共有時の説明文
 * @param props
 * @constructor
 */
export const RfpClientOneFileDescription = (props) => {
    const { className = '' } = props;
    return (_jsxs(ColorPaper, Object.assign({ bgColor: 'emphasis', className: className }, { children: [_jsx(Text, Object.assign({ color: 'base', size: 'sm' }, { children: "\u8CC7\u6599\u3092\u5171\u6709\u3059\u308B\u3068\u3001\u6307\u5B9A\u3057\u305F\u30B3\u30F3\u30B5\u30EB\u30BF\u30F3\u30C8\u306E\u63D0\u6848\u30C1\u30FC\u30E0\u306B\u5C55\u958B\u3055\u308C\u307E\u3059\u3002" })), _jsx(WithAnnotationText, Object.assign({ color: 'base', size: 'sm', symbol: 'base' }, { children: "\u63D0\u6848\u30C1\u30FC\u30E0\u5185\u3067\u30B9\u30E0\u30FC\u30BA\u306B\u60C5\u5831\u5171\u6709\u3059\u308B\u305F\u3081\u306E\u6A5F\u80FD\u3067\u3059\u3002" }))] })));
};
